import { frontendURL } from 'dashboard/helper/URLHelper.js';

const CampaignsPageRouteView = () =>
  import('./pages/CampaignsPageRouteView.vue');
const LiveChatCampaignsPage = () => import('./pages/LiveChatCampaignsPage.vue');
const SMSCampaignsPage = () => import('./pages/SMSCampaignsPage.vue');
const TelegramCampaignEditorPage = () =>
  import('./pages/TelegramCampaignEditorPage.vue');
const TelegramCampaignsPage = () => import('./pages/TelegramCampaignsPage.vue');
const TelegramCampaignReportPage = () =>
  import('./pages/TelegramCampaignReportPage.vue');
const LineCampaignsPage = () => import('./pages/LineCampaignsPage.vue');
const LineCampaignEditorPage = () =>
  import('./pages/LineCampaignEditorPage.vue');
const LineCampaignReportPage = () =>
  import('./pages/LineCampaignReportPage.vue');
const WhatsAppCampaignsPage = () => import('./pages/WhatsAppCampaignsPage.vue');
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { CAMPAIGN_PERMISSIONS } from 'dashboard/constants/permissions.js';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator', CAMPAIGN_PERMISSIONS],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_telegram_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_telegram_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'telegram',
          name: 'campaigns_telegram_index',
          meta,
          component: TelegramCampaignsPage,
        },
        {
          path: 'telegram/new',
          name: 'campaigns_telegram_new',
          meta,
          component: TelegramCampaignEditorPage,
        },
        {
          path: 'telegram/:id/edit',
          name: 'campaigns_telegram_edit',
          meta,
          component: TelegramCampaignEditorPage,
        },
        {
          path: 'telegram/:id/report',
          name: 'campaigns_telegram_report',
          meta,
          component: TelegramCampaignReportPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'line',
          name: 'campaigns_line_index',
          meta,
          component: LineCampaignsPage,
        },
        {
          path: 'line/new',
          name: 'campaigns_line_new',
          meta,
          component: LineCampaignEditorPage,
        },
        {
          path: 'line/:id/edit',
          name: 'campaigns_line_edit',
          meta,
          component: LineCampaignEditorPage,
        },
        {
          path: 'line/:id/report',
          name: 'campaigns_line_report',
          meta,
          component: LineCampaignReportPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
